export default __webpack_public_path__ + "static/media/Parent_Illustrations-17.72bd872f.svg";